import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchAndAdd = _resolveComponent("SearchAndAdd")!
  const _component_ToDoItem = _resolveComponent("ToDoItem")!
  const _component_SortValue = _resolveComponent("SortValue")!
  const _component_SortDate = _resolveComponent("SortDate")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.container)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.somethingListBox)
    }, null, 2),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.mainListBox)
    }, [
      _createElementVNode("ul", null, [
        _createVNode(_component_SearchAndAdd, {
          onAddTodo: _ctx.addTodo,
          onSearchChange: _ctx.searchChange,
          isAlreadyExists: _ctx.isAlreadyExists
        }, null, 8, ["onAddTodo", "onSearchChange", "isAlreadyExists"])
      ]),
      _hoisted_1,
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredList, (todo, index) => {
          return (_openBlock(), _createBlock(_component_ToDoItem, {
            onRemove: ($event: any) => (_ctx.removeTodo(index)),
            key: index,
            content: todo.content,
            addedDate: todo.addedDate,
            idx: index+1,
            checkIfAlreadyExists: _ctx.checkIfAlreadyExists(todo)
          }, null, 8, ["onRemove", "content", "addedDate", "idx", "checkIfAlreadyExists"]))
        }), 128))
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.buttonListBox)
    }, [
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, [
          _createVNode(_component_SortValue, { onSortValueClick: _ctx.sortValueClick }, null, 8, ["onSortValueClick"])
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_SortDate, { onSortDateClick: _ctx.sortDateClick }, null, 8, ["onSortDateClick"])
        ])
      ])
    ], 2)
  ], 2))
}